/* import __COLOCATED_TEMPLATE__ from './subject.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();